import { FiArrowLeft, FiBriefcase, FiMapPin } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/signin"
          className="inline-flex items-center text-sm font-medium text-orange-600 hover:text-orange-500 mb-6"
        >
          <FiArrowLeft className="mr-2 h-4 w-4" />
          Back to Sign In
        </Link>

        <div className="bg-white rounded-2xl p-8 card-shadow border border-gray-100">
          <h1 className="text-3xl font-bold text-gray-900">About Us</h1>
          <p className="mt-2 text-sm text-gray-500">Business and line of business clarification</p>

          <div className="mt-8 space-y-6">
            <div>
              <h2 className="text-lg font-semibold text-gray-900">Business Information</h2>
              <div className="mt-3 grid gap-2 text-sm text-gray-700">
                <p><span className="font-semibold">Business Name:</span> MK WHEELS LLP</p>
                <p><span className="font-semibold">Product Name:</span> UsedAdda</p>
              </div>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-gray-900 inline-flex items-center">
                <FiBriefcase className="mr-2 h-5 w-5 text-orange-500" />
                Line of Business
              </h2>
              <p className="mt-3 text-sm leading-7 text-gray-700">
                UsedAdda is a digital platform for used vehicle commerce operations. The platform helps
                sellers, agents, and buyers with vehicle listing workflows, inquiry handling, and
                marketplace coordination for pre-owned vehicles.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-gray-900 inline-flex items-center">
                <FiMapPin className="mr-2 h-5 w-5 text-orange-500" />
                Principal Place of Business
              </h2>
              <div className="mt-3 rounded-xl bg-orange-50 border border-orange-100 p-4 text-sm text-gray-800 space-y-1">
                <p>Building No./Flat No.: 12-71/7342</p>
                <p>Road/Street: NEHRU NAGAR</p>
                <p>Nearby Landmark: BIT-1</p>
                <p>City/Town/Village: Eluru</p>
                <p>District: Eluru</p>
                <p>State: Andhra Pradesh</p>
                <p>PIN Code: 534001</p>
              </div>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-100 flex flex-wrap gap-4 text-sm">
            <Link to="/policies" className="font-medium text-orange-600 hover:text-orange-500">Read Policies</Link>
            <Link to="/terms-and-conditions" className="font-medium text-orange-600 hover:text-orange-500">Terms & Conditions</Link>
            <Link to="/refund-policy" className="font-medium text-orange-600 hover:text-orange-500">Refund Policy</Link>
            <Link to="/contact" className="font-medium text-orange-600 hover:text-orange-500">Contact Details</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
